module.exports = __webpack_public_path__ + "static/media/Crustaceos.0de6b198.png";